import React, { useState } from 'react';
import { Row, Col, Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import OtpInput from 'react-otp-input';
import { postVerifyMfaSetup } from '../helper/api-methods';
import { showToast } from './Toast';

const SUPPORT_ERROR_MESSAGE = "error occured please contact wiserep support";
const getErrorMessage = (error) => {
    return typeof error === "string" ? error : error?.message || SUPPORT_ERROR_MESSAGE;
};

function MfaSetupPanel({ qrCodeDataUrl, manualEntryKey, mfaSetupToken, title, description, onVerified, onExpiredAction }) {
    const [mfaCode, setMfaCode] = useState("");
    const [loading, setLoading] = useState(false);
    const [expired, setExpired] = useState(false);

    const verifyMfaSetupHandler = () => {
        if (!mfaCode || mfaCode.length < 6) {
            showToast("error", "Invalid Code", "Please enter the 6-digit code from your authenticator app.");
            return;
        }
        setLoading(true);
        postVerifyMfaSetup("/auth/mfa/setup/verify", { mfaSetupToken, code: mfaCode }).then((data) => {
            setLoading(false);
            onVerified(data);
        }).catch((e) => {
            setLoading(false);
            const message = getErrorMessage(e);
            showToast("error", "Verification Failed", message);
            if (/expired|too many failed attempts/i.test(message)) {
                setExpired(true);
            }
        });
    }

    return (
        <>
            <div className='text-center'>
                <h3 className="fs-34 fw-500 mt-2 text-dark">{title || "Set up your Authenticator"}</h3>
                <p className="text-gray-200 p-0 mb-4 m-0">{description || "Scan this QR code with Microsoft Authenticator (or any TOTP app), then enter the 6-digit code it shows"}</p>
            </div>
            {qrCodeDataUrl ? (
                <div className="text-center mb-3">
                    <img src={qrCodeDataUrl} alt="Scan this QR code with your authenticator app" style={{ maxWidth: "220px", width: "100%" }} className="d-block mx-auto" />
                    <p className="text-gray-200 mt-2 mb-0">Can't scan? Enter this code manually:</p>
                    <code>{manualEntryKey}</code>
                </div>
            ) : null}
            <div className="d-flex justify-content-center gap-2 mb-4">
                <OtpInput
                    value={mfaCode}
                    onChange={setMfaCode}
                    numInputs={6}
                    shouldAutoFocus={true}
                    renderSeparator={<span> </span>}
                    renderInput={(props) => <input {...props} />}
                    inputStyle={{ width: "60px", height: "60px", borderRadius: "7px", border: "none", backgroundColor: "#f1f1f1", fontSize: "20px" }}
                    containerStyle={"otp-input"}
                />
            </div>
            {expired ? (
                <div className="text-center mb-3">
                    <span className="text-danger">
                        Your setup session expired. Please{' '}
                        {onExpiredAction ? (
                            <Link onClick={onExpiredAction}>log in</Link>
                        ) : (
                            <Link to="/login">log in</Link>
                        )}{' '}
                        to continue.
                    </span>
                </div>
            ) : null}
            <Row>
                <Col md={12} className='text-center'>
                    <div className="mt-4 text-center">
                        <Button disabled={loading || expired} onClick={() => { verifyMfaSetupHandler() }} className="btn-lg w-100 linear-gradient-btn">{loading ? "Please Wait" : "Verify & Finish"}</Button>
                    </div>
                </Col>
            </Row>
        </>
    );
}

export default MfaSetupPanel;
